module.exports = __webpack_public_path__ + "img/all-dark.41a582ad.svg";